import React from 'react';
import { FONTS } from '../../styles/tokens';
import type { GitHubBranch } from '../../lib/github-api';

interface Colors { text: string; textSecondary: string; card: string; border: string }

interface BranchPickerProps {
  branches: GitHubBranch[];
  value: string;
  onChange: (branch: string) => void;
  colors: Colors;
}

/** Dropdown for picking a branch within the selected repository. */
export function BranchPicker(props: BranchPickerProps): React.JSX.Element {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontFamily: FONTS.heading, fontSize: '11px', letterSpacing: '0.15em', color: props.colors.textSecondary, textTransform: 'uppercase' }}>
      Branch
      <select
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        style={{ padding: '8px', borderRadius: '6px', border: `1px solid ${props.colors.border}`, background: props.colors.card, color: props.colors.text }}
      >
        <option value="">Pick a branch…</option>
        {props.branches.map(branch => (
          <option key={branch.name} value={branch.name}>{branch.name}</option>
        ))}
      </select>
    </label>
  );
}
